import {
  EyeStroke,
  FileMultipleStroke,
  Pencil1Stroke,
  PlusStroke,
  RefreshCircle1ClockwiseStroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';

interface ActionBarProps {
  onAddClick: () => void;
  onEditClick: () => void;
  onDeleteClick: () => void;
  onCopyClick: () => void;
  onRefreshClick: () => void;
  onViewClick: () => void;
  onImportExcel?: () => void;
  isRowActionDisabled?: boolean;
  isDeleteDisabled?: boolean;
}

export const ActionBar = ({
  onAddClick,
  onEditClick,
  onDeleteClick,
  onCopyClick,
  onRefreshClick,
  onViewClick,
  onImportExcel,
  isRowActionDisabled = true,
  isDeleteDisabled = true
}: ActionBarProps) => {
  return (
    <ActionBarV2 titleComponent={<h1 className='text-xl font-bold'>Danh mục tài khoản</h1>}>
      <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAddClick} />
      <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditClick} disabled={isRowActionDisabled} />
      <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDeleteClick} disabled={isDeleteDisabled} />
      <ActionButtonV2 icon={FileMultipleStroke} title='Sao chép' onClick={onCopyClick} disabled={isRowActionDisabled} />
      <ActionButtonV2 icon={EyeStroke} title='Xem' onClick={onViewClick} disabled={isRowActionDisabled} />
      <ActionButtonV2
        icon={RefreshCircle1ClockwiseStroke}
        title='Tải lại'
        onClick={onRefreshClick}
        variant='secondary'
      />
      <MenuButtonV2
        items={[
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={555} />,
            onClick: () => {},
            group: 0
          },
          {
            title: 'Tải mẫu Excel',
            icon: <AritoIcon icon={28} />,
            onClick: () => {},
            group: 1
          },
          {
            title: 'Lấy dữ liệu từ Excel',
            icon: <AritoIcon icon={29} />,
            onClick: () => onImportExcel?.(),
            group: 1
          }
        ]}
      />
    </ActionBarV2>
  );
};
